/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
//import { useState } from 'react';

//import { Accordion, Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { ToastContainer /*,toast*/ } from 'react-toastify';

//import moment from 'moment';

import { ICartState } from '@msdyn365-commerce/global-state';

import { AsyncResult, CartLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { validateForCheckoutAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
// import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

import { getProductUrlSync /*generateImageUrl*/, ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

import { Node } from '@msdyn365-commerce-modules/utilities';
//import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { generateErrorLog } from '../../actions/helper-functions';
import { FormDetails } from '../../actions/ecomm-interfaces';

// import { deleteBTGPCartLineAsync, /*deleteAllInvalidBTGPCartLineAsync/*, getFirstSerialAsync, checkSerialAsync*/ } from '../../actions/DataActionExtension.g';
// import { FormDetails, CartItem } from '../../actions/ecomm-interfaces';
// import { createOrUpdateCartline, /*generateErrorLog*/ } from '../../actions/helper-functions';

import { ICartlinesViewProps } from './components/eshop-cart-line-items';

import { ICartViewProps } from './eshop-cart';

//import resource from '../../resources/field-labels.json';

interface IDimensionStrings {
    /** String for size key  */
    sizeString?: string;
    /** String for color key  */
    colorString?: string;
    /** String associated with the configuration product dimension  */
    configString?: string;
    /** String for style key  */
    styleString?: string;
    /** String for amount key  */
    amountString?: string;
}

const _renderCartlines = (
    cartLines: ICartlinesViewProps[] | undefined,
    cartEmptyText: string,
    waitingComponent: React.ReactNode,
    cartLoadingStatus: string,
    cartDataResult: boolean,
    addTitle: string,
    editTitle: string,
    removeTitle: string,
    props: ICartViewProps
): JSX.Element[] | JSX.Element => {
    if (cartLoadingStatus) {
        return <>{cartLoadingStatus}</>;
    }

    const destructDimensionStrings = {
        sizeString: props.config.sizeDimension,
        colorString: props.config.colorDimension,
        styleString: props.config.styleDimension,
        configString: props.config.configDimension,
        amountString: props.config.amountDimension
    };

    if (cartLines) {
        //const localeCode = props.context.request.locale.split('-')[0];

        return cartLines.map((cartLine, index) => {
            // const cartLineDataIndex = props.cartLineData.findIndex(cl => cl['CartLineID'] === cartLine.data?.cartline.LineId);

            const productDimensions = cartLine.data?.product && renderProductDimensions(cartLine.data?.product, destructDimensionStrings);

            let url = '';

            if (productDimensions) {
                url = constructVariantUrl(cartLine.data?.product!);
            }

            const childTotalCost = 0;

            const price = `$` + `${cartLine.data?.cartline.Price! * cartLine.data?.cartline.Quantity! + childTotalCost}`;
            const priceHTML = isMobile ? <div className='price col-12'>{price}</div> : <div className='price col-sm-12'>{price}</div>;

            //if (cartLineDataIndex < 0) {
            return (
                <div className='eshop-cart-item row' key={index}>
                    <div className='col-4 col-sm-2'>{cartLine.cartline}</div>
                    <div className='col-8 col-sm-10 row'>
                        <div className='col-12 row'>{!isMobile && priceHTML}</div>
                        <div className='product col-sm-6'>
                            {cartLine.data?.product?.Name}
                            {ArrayExtensions.hasElements(productDimensions) ? <p className='row'>{productDimensions}</p> : ''}
                            <div className='row'>
                                {props.config.quantityText}: {cartLine.data?.cartline?.Quantity}
                            </div>
                            <div className='row'>Remarks : {getRemarksFromCartLine(cartLine.data?.cartline)}</div>
                        </div>
                        <div className='information row col-sm-6'></div>
                        <div className='col-12 row'>
                            <div className='actions col-10 col-sm-12'>
                                <a
                                    href={`${getProductUrlSync(
                                        cartLine.data?.product!,
                                        props.context.actionContext,
                                        undefined
                                    )}?addtocart=true`}
                                >
                                    {addTitle}
                                </a>
                                <p>|</p>
                                <a
                                    href={`${getProductUrlSync(
                                        cartLine.data?.product!,
                                        props.context.actionContext,
                                        undefined
                                    )}${`?cartlineId=${cartLine.data?.cartline.LineId}${url}`}`}
                                >
                                    {editTitle}
                                </a>
                                <p>|</p>
                                <button className='remove' onClick={() => removeItem(cartLine.data!.cartline, props)}>
                                    {removeTitle}
                                </button>
                            </div>
                            {isMobile && priceHTML}
                        </div>
                    </div>
                    {index < cartLines.length - 1 && (
                        <div className='col-12'>
                            <hr className='line-end' />
                        </div>
                    )}
                </div>
            );
        });
    } else {
        // Disabled following elements:
        // {backToShoppingButton} - after <p/> tag
        return cartDataResult ? (
            <div className='eshop-cart-item'>
                <p className='empty'>{cartEmptyText}</p>
            </div>
        ) : (
            <>{waitingComponent}</>
        );
    }
};

export const getRemarksFromCartLine = (cartLine: CartLine | undefined) => {
    if (cartLine) return (cartLine.AttributeValues?.find(val => val.Name === 'CartRemark') as { TextValue: string })?.TextValue || '';
    return '';
};

const removeItem = async function(cartlineToRemove: CartLine, props: ICartViewProps) {
    if (props.data.cart.result) {
        const cartLinesToRemove = [cartlineToRemove.LineId!];

        const logDetail = 'Capturing user actions, File: eshop-cart.View.tsx, funtion: removeItem';
        const item: FormDetails = {
            CartLineID: cartlineToRemove.LineId!,
            CartID: '',
            CartLineComment: '',
            ParentCartLineID: '',
            ProductID: '',
            EventID: '',
            EventName: '',
            SerialID: '',
            SerialNumber: '',
            SerialName: '',
            Name_1: '',
            Name_2: '',
            Name_3: '',
            Name_4: '',
            Name_5: '',
            Name_6: '',
            Name_7: '',
            Name_8: '',
            Name_9: '',
            Name_10: '',
            Name_11: '',
            Name_12: '',
            Name_13: '',
            Name_14: '',
            Name_15: '',
            Name_16: '',
            Name_17: '',
            Name_18: '',
            Name_19: '',
            Name_20: '',
            Remarks: '',
            Message: '',
            Category: '',
            DedicatedBy: '',
            HasTaxDeduction: false,
            Nric: '',
            BuildingName: '',
            UnitNumber: '',
            PostalCode: '',
            PhoneNumber: '',
            Country: '',
            SchoolName: '',
            CompanyName: '',
            DonationOption: '',
            BlessingOption: '',
            LightOption: '',
            ValidFrom: '',
            ValidTo: '',
            DedicationPeriod: '',
            StartDate: '',
            Gender: '',
            SurgeryDate: '',
            BirthDate: '',
            BirthTime: '',
            BirthDate_2: '',
            BirthTime_2: '',
            DeathDate: '',
            DeathTime: '',
            DeceasedRelationship: '',
            NameChange: '',
            OldName_1: '',
            OldName_2: '',
            ChineseName: '',
            NameNextKin: '',
            ContactNumber: '',
            ContactNumberNextKin: '',
            PassportNumber: '',
            PassportExpiryDate: '',
            PassportIssuedDate: '',
            Consent: 0,
            IsInsuranceIncluded: 0
        };
        await generateErrorLog(props.context, 'User clicked Remove button in eShop cart page', logDetail, item);

        const input = { cartLineIds: cartLinesToRemove };

        await props.data.cart.result.removeCartLines(input).catch(error => {
            props.telemetry.warning(error);
            props.telemetry.debug('Unable to Remove Cart Line');
        });

        await validateCart(props).catch(error => {
            props.telemetry.warning(error);
            props.telemetry.debug('Unable to validate Cart');
        });
    }
};

const checkCartValidity = async function(props: ICartViewProps) {
    const allitemsValidCheck = true;

    //const localeCode = props.context.request.locale.split('-')[0];

    if (allitemsValidCheck) {
        await checkoutProcess(props);
    }
};

//Function checks for serial number validity (if applicable), and redirects customers to the checkout page to complete payment.
const checkoutProcess = async function(props: ICartViewProps) {
    // Redirecting customer to check out page.
    window.location.href = props.config.checkoutUrl
        ? props.config.checkoutUrl.linkUrl.destinationUrl
            ? props.config.checkoutUrl.linkUrl.destinationUrl
            : '/eshop/checkout'
        : '#';
};

const validateCart = async function(props: ICartViewProps, retry: boolean = true): Promise<void> {
    // if (!this.isQuantityLimitsFeatureEnabled) {
    //     return AsyncResult.resolve();
    // }

    const {
        data: { cart: cart }
    } = props;

    let cartResult: ICartState;

    try {
        cartResult = await cart;
    } catch (error) {
        const msg = (error as unknown) as string;

        props.telemetry.warning(msg);
        props.telemetry.debug('Unable to get cart');

        return AsyncResult.resolve();
    }

    const cartVersion = cartResult.cart?.Version;

    if (cartVersion) {
        try {
            await validateForCheckoutAsync({ callerContext: props.context.actionContext }, cartResult?.cart?.Id, cartVersion);
            // this.setState({cartlinesErrors: validationResult.ValidationFailuresByCartLines || []});
            return AsyncResult.resolve();
        } catch (error) {
            const msg = (error as unknown) as any;

            if (retry && msg.name === 'Microsoft_Dynamics_Commerce_Runtime_InvalidCartVersion') {
                try {
                    await cartResult.refreshCart({});
                } catch (refreshError) {
                    const msg = (refreshError as unknown) as string;

                    props.telemetry.warning(msg);
                    props.telemetry.debug('Unable to refresh Cart');

                    return AsyncResult.resolve();
                }
                try {
                    await validateCart(props, false);

                    return AsyncResult.resolve();
                } catch (validateError) {
                    const msg = (validateError as unknown) as string;

                    props.telemetry.warning(msg);
                    props.telemetry.debug('Unable to validate Cart');

                    return AsyncResult.resolve();
                }
            }

            props.telemetry.warning(msg);
            props.telemetry.debug('Unable to validate Cart');

            return AsyncResult.resolve();
        }
    } else {
        props.telemetry.warning('Cart version not found for Cart validation request.');

        return AsyncResult.resolve();
    }
};

const constructVariantUrl = (Product: SimpleProduct) => {
    if (!Product || !Product.Dimensions) {
        return '';
    }

    let color = '';
    let size = '';
    let config = '';
    let style = '';

    Product.Dimensions.map(productDimension => {
        if (productDimension.DimensionTypeValue === 1) {
            if (productDimension.DimensionValue) {
                color = `${`&color=${productDimension.DimensionValue.Value}`}`;
            }
        }

        if (productDimension.DimensionTypeValue === 2) {
            if (productDimension.DimensionValue) {
                config = `${`&config=${productDimension.DimensionValue.Value}`}`;
            }
        }

        if (productDimension.DimensionTypeValue === 3) {
            if (productDimension.DimensionValue) {
                size = `${`&size=${productDimension.DimensionValue.Value}`}`;
            }
        }

        if (productDimension.DimensionTypeValue === 4) {
            if (productDimension.DimensionValue) {
                style = `${`&style=${productDimension.DimensionValue.Value}`}`;
            }
        }
    });

    return size + color + config + style;
};

const renderProductDimensions = (Product: SimpleProduct, DimensionStrings: IDimensionStrings) => {
    if (!Product || !Product.Dimensions) {
        return [];
    }

    return Product.Dimensions.map(productDimension => {
        if (productDimension.DimensionTypeValue === 1) {
            return (
                <div key={`${Product.RecordId}ProductDimensions1`} className='msc-cart-line__product-variant-item'>
                    <span className='msc-cart-line__product-variant-color'>
                        {DimensionStrings.colorString}:
                        <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span>
                    </span>
                </div>
            );
        }

        if (productDimension.DimensionTypeValue === 2) {
            return (
                <div key={`${Product.RecordId}ProductDimensions2`} className='msc-cart-line__product-variant-item'>
                    <span className='msc-cart-line__product-configuration'>
                        {DimensionStrings.configString}:
                        <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span>
                    </span>
                </div>
            );
        }

        if (productDimension.DimensionTypeValue === 3) {
            return (
                <div key={`${Product.RecordId}ProductDimensions3`} className='msc-cart-line__product-variant-item'>
                    <span className='msc-cart-line__product-variant-size'>
                        {DimensionStrings.sizeString}:
                        <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span>
                    </span>
                </div>
            );
        }

        if (productDimension.DimensionTypeValue === 4) {
            return (
                <div key={`${Product.RecordId}ProductDimensions4`} className='msc-cart-line__product-variant-item'>
                    <span className='msc-cart-line__product-variant-style'>
                        {Product.IsGiftCard ? DimensionStrings.amountString : DimensionStrings.styleString}:
                        <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span>
                    </span>
                </div>
            );
        }
        return null;
    });
};

const EshopCartView: React.FC<ICartViewProps> = (props: ICartViewProps) => (
    <div className='eshop-cart' id={props.id} {...props.renderModuleAttributes(props)}>
        <Node {...props.CartlinesWrapper}>
            {_renderCartlines(
                props.cartlines,
                props.resources.emptyCartText,
                props.waitingComponent,
                props.cartLoadingStatus,
                props.cartDataResult,
                props.config.addTitle,
                props.config.editTitle,
                props.config.removeTitle,
                props
            )}
        </Node>
        <div>{/*{_renderUnavailableCartlinesWrapper(props.cartLoadingStatus, props)}*/}</div>

        {isMobile && (
            <button
                className='checkout msc-btn'
                onClick={e => {
                    (e.target as HTMLButtonElement).disabled = true;
                    void checkCartValidity(props);
                    (e.target as HTMLButtonElement).disabled = false;
                }}
            >
                {props.config.checkoutUrl?.linkText}
            </button>
        )}

        <ToastContainer autoClose={5000} closeButton={false} />

        {props.storeSelector}
    </div>
);

export default EshopCartView;
